const makeUrlResolver = (endpoint) => (id) =>
  `api/${endpoint}${id ? `/${id}` : ''}`;

const endpoints = {
  auth: 'api/auth/local',
  upload: 'api/upload',

  objects: makeUrlResolver('objects'),
  objectsSuggested: makeUrlResolver('object-suggesteds'),
  objectSuggestedAccept: (id) => `api/object-suggesteds/${id}/accept`,
  objectSuggestedSubmit: 'api/object-suggested/submit',
  categories: makeUrlResolver('categories'),
  subcategories: makeUrlResolver('subcategories'),
  routes: makeUrlResolver('routes'),
  coinSpendCodes: makeUrlResolver('coin-spend-codes'),
  coinSpends: makeUrlResolver('coin-spends'),
  appVersion: 'api/app-version',
  appContactInfo: 'api/app-contact-info',
  statisticsReport: 'api/statistics/report', // Statistics API (not under routes)
  routePurchaseCreatePayment: 'api/route-purchases/create-payment',
  routePurchaseCompleteFreePurchase: 'api/route-purchases/complete-free-purchase',
  routePurchaseCanPurchase: (routeId) =>
    `api/route-purchases/can-purchase/${routeId}`,
  accountInfoByUserId: (userId) => `api/account-infos/by-user/${userId}`,
  accountInfoMe: 'api/account-infos/me',
  accountInfoAcceptInvite: 'api/account-infos/accept-invite',
  discountCodes: makeUrlResolver('discount-codes'),
  discountCodeValidate: 'api/discount-codes/validate',
  prizes: makeUrlResolver('prizes'),
  prizesForProfile: 'api/prizes/for-profile',
};

export default endpoints;
